const agent_info= {
    malory: {
        name:"Mallory Earp, Associate Broker",
        company: "Realty One of New Mexico",
        mobile_phone:"505-585-0202",
        office_phone:"505-883-9400",
        email:"malearp@gmail.com",
        mls_info:"MLS#: 1018763",
        agent: true
    },
    megan:{
        name:"Megan Boyden",
        phone:"505.369.6929",
        email:"meg.b@bigdog.properties"
    }
}


export default agent_info